import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Modal } from 'react-bootstrap';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import Button from '@/shared/components/Button';
import intlShape from '@/shared/utils/intlShape';
import messages from '../employeeMessages';

class DeleteEmployeeModal extends Component {
  state = {
    keepVisible: true,
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    saving: PropTypes.bool,
    employee: PropTypes.object,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    saving: false,
    employee: null,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.setState({ keepVisible: true });
    }
  }

  handleKeepVisibleChange = e => {
    this.setState({ keepVisible: e.target.checked });
  };

  handleSave = () => {
    const { onSave } = this.props;
    const { keepVisible } = this.state;

    onSave({
      hidden: !keepVisible,
    });
  };

  handleClose = () => {
    const { onClose } = this.props;
    this.setState({ keepVisible: true });
    onClose();
  };

  render() {
    const { show, saving, employee, intl } = this.props;
    const { keepVisible } = this.state;

    if (!employee) return null;

    return (
      <Modal show={show} onHide={this.handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>
            <FormattedMessage {...messages.Delete} />?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <FormattedMessage {...messages.DeleteEmployeeQuestion} />
          </p>
          <div className="margin10T">
            <label className="react-toggle-wrapper toggle-lg">
              <Toggle
                checked={keepVisible}
                onChange={this.handleKeepVisibleChange}
                icons={false}
                disabled={saving}
              />
              <span className="label-text margin10L">
                <FormattedMessage {...messages.KeepShowingEmployeeInApplication} />
              </span>
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.handleClose} disabled={saving}>
            <FormattedMessage {...messages.Cancel} />
          </Button>
          <Button
            onClick={this.handleSave}
            disabled={saving}
            btnClassName="btn-inverse"
            showProgress={saving}
          >
            <FormattedMessage {...messages.Ok} />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default injectIntl(DeleteEmployeeModal);
